import { cn } from '@shared/components/shadcn';
import { ChevronRight } from '@shared/icons';
import Image from 'next/image';
import Link from 'next/link';
import type { ComponentProps } from 'react';
import type { HomeWinnersStoryLabelColour } from '../types';

const LABEL_COLOUR_CLASSNAME: Record<HomeWinnersStoryLabelColour, string> = {
  jackpot: 'text-kenogo-games-jackpot-base',
  bonus: 'text-prize-tier-bonus',
};

type HomeWinnersStoryCardProps = Omit<ComponentProps<typeof Link>, 'children'> & {
  avatarSrc: string;
  winnerIntro: string;
  prize: string;
  gameLabel: string;
  labelColour: HomeWinnersStoryLabelColour;
  'data-testid'?: string;
};

function HomeWinnersStoryCard({
  avatarSrc,
  winnerIntro,
  prize,
  gameLabel,
  labelColour,
  className,
  'data-testid': dataTestId = 'home-winners-story-card',
  ...props
}: HomeWinnersStoryCardProps) {
  return (
    <Link
      {...props}
      data-testid={dataTestId}
      data-track-container="Winner Story"
      data-track-name={prize}
      className={cn(
        'flex h-full items-center gap-2 rounded-xl bg-container-base p-4 text-left shadow-[0_4px_18px_-2px_var(--color-shadow-l)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-active',
        className
      )}
    >
      <Image src={avatarSrc} alt="" width={56} height={56} className="size-14 shrink-0 rounded-full object-cover" />
      <div className="min-w-0 flex-1">
        <p className="paragraph-s-strong text-foreground-subtle">{winnerIntro}</p>
        <h3 className="display-xs-strong line-clamp-1 text-foreground">{prize}</h3>
        <p className={cn('paragraph-s-strong line-clamp-1', LABEL_COLOUR_CLASSNAME[labelColour])}>{gameLabel}</p>
      </div>
      <ChevronRight size="small" aria-hidden className="shrink-0 text-foreground-subtle" />
    </Link>
  );
}

export { HomeWinnersStoryCard, type HomeWinnersStoryCardProps };
